import { useTranslation } from 'react-i18next';
import { LogOut, Menu, Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { useSidebarStore } from '@/stores/sidebarStore';

export function Topbar() {
  const { t, i18n } = useTranslation();
  const { user, logout } = useAuth();
  const { setMobileOpen } = useSidebarStore();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'sr' ? 'en' : 'sr';
    i18n.changeLanguage(newLang);
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <header className="h-16 border-b bg-card flex items-center justify-between px-4 lg:px-6 sticky top-0 z-30">
      {/* Mobile menu button */}
      <button
        onClick={() => setMobileOpen(true)}
        className="lg:hidden p-2 rounded-md hover:bg-accent"
      >
        <Menu className="h-5 w-5" />
      </button>

      {/* Title */}
      <div className="hidden lg:block">
        <h1 className="text-sm font-semibold text-muted-foreground">Super Admin</h1>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-3">
        {/* Language toggle */}
        <Button variant="ghost" size="sm" onClick={toggleLanguage} className="gap-1.5">
          <Globe className="h-4 w-4" />
          <span className="text-xs uppercase">{i18n.language}</span>
        </Button>

        {/* User info */}
        <div className="hidden sm:block text-right">
          <p className="text-sm font-medium">{user?.firstName || user?.email}</p>
          <p className="text-xs text-muted-foreground">{user?.role}</p>
        </div>

        {/* Logout */}
        <Button variant="ghost" size="icon" onClick={handleLogout} title={t('auth.logout')}>
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
}
